import "./detail.scss";
import React, { useEffect, useState } from "react";
import tmdbApi from "../../api/tmdbApi";
import StreamingPlayer from "./StreamingPlayer";

const EpisodeList = ({ id }) => {
  const [episodes, setEpisodes] = useState([]);
  const [selectedEpisode, setSelectedEpisode] = useState(null);
  const [season, setSeason] = useState(1);
  const [seasons, setSeasons] = useState([]);

  // 🟡 Get all seasons
  useEffect(() => {
    const getDetails = async () => {
      try {
        const response = await tmdbApi.getTvDetail(id);
        console.log("TV Detail Response:", response);

        if (response.seasons) {
          // All seasons include Season 0 (Specials) as well
          setSeasons(response.seasons);
        }
      } catch (err) {
        console.error("Error fetching TV details:", err);
      }
    };
    getDetails();
  }, [id]);

  // 🟡 Get episodes for selected season
  useEffect(() => {
    const getEpisodes = async () => {
      try {
        const response = await tmdbApi.getTvEpisodes(id, season);
        setEpisodes(response.episodes || []);
      } catch (err) {
        console.error("Error fetching episodes:", err);
      }
    };
    getEpisodes();
  }, [id, season]);

  return (
    <div className="episode-list">
      {/* Season Selector */}
      <div className="season-selector">
        <label>Season: </label>
        <select
          value={season}
          onChange={(e) => setSeason(Number(e.target.value))}
        >
          {seasons.map((s) => (
            <option key={s.id} value={s.season_number}>
              {s.season_number === 0
                ? "Specials"
                : `Season ${s.season_number}`}
            </option>
          ))}
        </select>
      </div>

      {/* Episodes List */}
      <ul className="episode-grid">
        {episodes.map((ep) => (
          <li
            key={ep.id}
            className="episode-item"
            onClick={() => setSelectedEpisode(ep.episode_number)}
          >
            {ep.still_path && (
              <img
                src={`https://image.tmdb.org/t/p/w300${ep.still_path}`}
                alt={ep.name}
              />
            )}
            <div className="episode-info">
              <h3>
                Episode {ep.episode_number}: {ep.name}
              </h3>
              <p>{ep.overview || "No description available."}</p>
            </div>
          </li>
        ))}
      </ul>

      {/* Streaming Player */}
      {selectedEpisode && (
        <div className="episode-player">
          <StreamingPlayer
            id={id}
            category="tv"
            season={season}
            episode={selectedEpisode}
          />
        </div>
      )}
    </div>
  );
};

export default EpisodeList;
